module.exports = __webpack_public_path__ + "img/jomalone_logo_header1.345a7e33.png";